var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page__comsobase-lesson"},[_c('SimpleBreadcrumbs',{attrs:{"links":[
      {
        name: 'Головна сторінка',
        href: '/'
      },
      {
        name: 'Навчання',
        href: `/uk/profile/cosmobase`
      },
       {
        name: _vm.content ? _vm.content.title : 'Курс',
        href: `/uk/cosmobase-course/${ _vm.$route.params.id }`
      },
      {
        name: 'Меню курсу',
        href: '/uk/cosmobase-lesson'
      }
    ]}}),_c('ComsobaseLessonActions'),_c('ComsobaseLessonInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }